// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries
import {getAuth,GoogleAuthProvider} from "firebase/auth"
import {getFirestore} from "firebase/firestore"


// Your web app's Firebase configuration
const firebaseConfig = {

  apiKey: "AIzaSyBrLBWrYXSKnlFO7bVD6Vs7qKem39WBZIg",

  authDomain: "photofusiongame.firebaseapp.com",

  projectId: "photofusiongame",

  storageBucket: "photofusiongame.appspot.com",

  messagingSenderId: "383119973468",

  appId: "1:383119973468:web:efc193d4d551aec8a89a99"

};

// Initialize Firebase
const app = initializeApp(firebaseConfig);

export const db = getFirestore(app);
export const auth = getAuth(app)
export const provider = new GoogleAuthProvider();


